import React from "react";

import { Outlet, useLocation } from "react-router";
import { Link } from "react-router-dom";

import classNames from "classnames";

import AdvertisersTable from "./components/SponsorsTable";

import { store } from "../../..";
import { globalActions } from "../../../features/global/globalSlice";

export const loader = async () => {
    const promises = [];
    const sponsors = store.getState().global.sponsors;

    !sponsors.length &&
        promises.push(store.dispatch(globalActions.getSponsors()));

    await Promise.all(promises);

    return null;
};

const Advertisers = (): React.JSX.Element => {
    const location = useLocation();
    const isOnIndexPage = /advertisers\/?$/.test(location.pathname);

    return (
        <div className={classNames("advertisersContent")}>
            {isOnIndexPage && (
                <Link
                    className={classNames("btn", "btn-primary", "mb-3")}
                    to="/site-management/advertisers/add"
                >
                    Add New Advertiser
                </Link>
            )}
            {isOnIndexPage ? <AdvertisersTable /> : <Outlet />}
        </div>
    );
};

export default Advertisers;
